module.exports = __webpack_public_path__ + "static/media/product-group.cb7269ab.png";